export const gaugeValues = [
  { color: "#F97066", text: "low" },
  { color: "#FEC84B", text: "medium" },
  { color: "#12B76A", text: "high" },
];

export const channelAnalysisValues = [
  { color: "#12B76A", text: "keepFocus" },
  { color: "#FEC84B", text: "raiseFocus" },
  { color: "#F97066", text: "reduceFocus" },
  { color: "#667085", text: "neutral" },
];

export const revenueColorsValue = [
  { color: "#12C5D0", text: "total" },
  { color: "#AFAFAF", text: "unavailable" },
  { color: "#68D9AC", text: "compatible" },
  { color: "#FDB022", text: "incompatible" },
];

export const getrevenueColorsByindex = (
  index: number,
  startingIndex: number = 0
) => {
  return revenueColorsValue[startingIndex + index].color;
};

export const similarityColors = ["#6998F7", "#FDB022", "#68D9AC", "#F97066"];
export const comparisonColors = ["#6998F7", "#68D9AC"];
